import { IPoint } from '../plan-primitive';
import { EPaneId } from '../sheet-layout';
import { IDxfPoint } from './dxf-entities';

/**
 * Paper millimetres in a sheet pixel. The sheet is laid out in CSS pixels of 1/96 inch, every
 * view at its standard scale, so the sheet in pixels is the paper sheet: a pixel is 25.4/96 mm.
 */
export const PAPER_MM_PER_PX: number = 25.4 / 96;

/** How one pane's pixels become millimetres of the file, and which view the entities belong to. */
export interface IDxfPaneFit {
    pxPerMm: number;
    origin: { x: number; y: number };
    paneId: EPaneId;
    /**
     * File millimetres per paper millimetre: the view's scale denominator in model space, 1 in
     * paper space. Text heights, slashes and dash lengths are paper sizes times this.
     */
    scale: number;
}

/** The denominator N of «1 : N» a pane is drawn at, from its pixels per millimetre. */
export function paneDenominator(pxPerMm: number): number {
    return 1 / (pxPerMm * PAPER_MM_PER_PX);
}

/** Pane-local pixels → millimetres of the view, Y turned up. */
export function toPaneMm(fit: IDxfPaneFit, point: IPoint): IDxfPoint {
    return [(point[0] - fit.origin.x) / fit.pxPerMm, -(point[1] - fit.origin.y) / fit.pxPerMm];
}
